<template>
  <!-- PC版本 -->
  <AboutUsForPc v-if="!isMobile" />
  
  <!-- Mobile版本 -->
  <MobileAboutUs v-else />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useDeviceDetection } from "@/utils/deviceDetection";
import { pushToDataLayer } from "../utils/gtm";
import { useHead } from "@vueuse/head";
import { useI18n } from 'vue-i18n';
import { computed } from "vue";
import AboutUsForPc from "../components/AboutUsForPc.vue";
import MobileAboutUs from "../components/MobileAboutUs.vue";
import { getSEO } from '../utils/seoConfig';

const { isMobile } = useDeviceDetection();
const { locale } = useI18n();

// 动态多语言 SEO
const seo = computed(() => getSEO(locale.value, 'about'));

useHead({
  title: computed(() => seo.value.title),
  meta: [
    { name: "description", content: computed(() => seo.value.description) },
    { name: "keywords", content: computed(() => seo.value.keywords) },
    { property: "og:title", content: computed(() => seo.value.title) },
    { property: "og:description", content: computed(() => seo.value.description) },
  ],
});

onMounted(() => {
  pushToDataLayer("page_view", {
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: document.referrer,
  });
});
</script>
